import { render, staticRenderFns } from "./CoursePackages.vue?vue&type=template&id=3cc631fc&scoped=true"
import script from "./CoursePackages.vue?vue&type=script&lang=js"
export * from "./CoursePackages.vue?vue&type=script&lang=js"
import style0 from "./CoursePackages.vue?vue&type=style&index=0&id=3cc631fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc631fc",
  null
  
)

export default component.exports